import React from 'react';
import { useSelector } from 'react-redux';

export default function Header() {
  const data = useSelector((state) => state.data.data);
  return (
    <header>
      <div className="headline">{data?.headline}</div>
      {/* <p>{data?.description}</p> */}
    </header>
  );
}
